import { render } from "./index.vue?vue&type=template&id=74f8e9c0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabRouterView/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74f8e9c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74f8e9c0', __exports__)) {
    api.reload('74f8e9c0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=74f8e9c0", () => {
    api.rerender('74f8e9c0', render)
  })

}


export default __exports__